import OrchesHero from './orchesHero/OrchesHero'
import OrchesWhat from './orchesWhat/OrchesWhat'
import OrchesService from './orchesService/OrchesService'
import OrchesTestimonial from './orchesTestimonial/OrchesTestimonial'
import OrchesApproach from './orchesApproach/OrchesApproach'
import OrchesBenefit from './orchesBenefits/OrchesBenefits'
import OrchesCapability from './orchesCapability/OrchesCapability'
import OrchesChoose from './orchesChoose/OrchesChoose'

export default function Orches() {
  return (
    <div>
        <OrchesHero/>
        <OrchesWhat/>
        <OrchesCapability/>
        <OrchesBenefit/>
        <OrchesApproach/>
        <OrchesChoose/>
        <OrchesTestimonial/>
        <OrchesService/>
    </div>
  )
}
